import axios from '../../utils/ajax';
import Global from '../../utils/global';
import Constants from '../../utils/constants';
export const userInfoApi = (params) => {
  let baseUrl = Global.getCloudRbacUrl();
  if(Global.getCustomConfig()['CAS_LOGIN']){
    baseUrl = Global.getBaseUrl();
  }
  let url = Global.getCustomApi(Constants.CUSTOM_API_KEY_AUTHORITY_ME) || (baseUrl + '/authority/me');
	return axios.ajax(url, 'get', params);
};
export const changePasswordApi = (params) => {
  let url = Global.getCustomApi(Constants.CUSTOM_API_KEY_CHANGE_PASSWORD) || (Global.getCloudRbacUrl() + '/user/password');
	return axios.ajax(url, 'put', params);
};

export const updateHomePage = (params) => {
  let url = Global.getCustomApi(Constants.CUSTOM_API_KEY_UPDATE_SYSTEM_HOMEPAGE) || (Global.getBaseUrl() + '/system/homePage');
	return axios.ajax(url, 'post', params);
};
export const getLocalAddr = (params) => {
  let url = Global.getCustomApi(Constants.CUSTOM_API_KEY_GET_IP_ADDR) || (Global.getBaseUrl() + '/common/info/ip');
	return axios.ajax(url, 'get', params);
};
// 读取配置,获取水印内容
export const getWatermarkInfo = (params) => {
  let url = Global.getCustomApi(Constants.CUSTOM_API_KEY_GET_WATERMARK_INFO) || (Global.getBaseUrl() + '/common/info/watermark');
  return axios.ajax(url, 'get', params);
};
// 个人中心中显示个人的操作日志
export const getOprationLogApi = (params) => {
    return axios.ajax(Global.getBaseUrl() + '/login/log/message', 'get', params);
};
// 个人中心中显示个人的操作日志筛选接口
export const searchOprationLogApi = (params) => {
    return axios.ajax(Global.getBaseUrl() + '/login/log/all/message', 'get', params);
};
// 个人中心中显示个人的操作日志状态接口
export const getStatusApi = () => {
    return axios.ajax(Global.getBaseUrl() + '/common/config/getLoginStatus', 'get', {});
};
//获取过期时间
export const getOutOfDateTimeApi = (params) => {
    let url = Global.getCustomApi(Constants.CUSTOM_API_KEY_GET_EXPIRED_DATETIME) || (Global.getCloudRbacUrl() + '/authentication/expireTime');
    return axios.ajax(url, 'get', params);
};

export const heartbeatApi = (params) => {
  let url = Global.getCustomApi(Constants.CUSTOM_API_KEY_HEARTBEAT) || (Global.getBaseUrl() + '/heartbeat');
  return axios.ajax(url, 'post', params);
};

export const getOnlineUserApi = (params) => {
    let url = Global.getBaseUrl() + '/oauth/onlineUser';
    return axios.ajax(url, 'post', params);
};

export const kickOnlineUserApi = (params) => {
    let url = Global.getBaseUrl() + '/oauth/kick/onlineUser';
    return axios.ajax(url, 'post', params);
};
export const downloadHistApi = (params) => {
  let url = Global.getBaseUrl() + '/commonDownload/load/hist';
  return axios.ajax(url, 'get', params);
};
export const departmentApi = (params) => {
  let url = Global.getCloudRbacUrl() + '/department/tree_parent';
  return axios.ajax(url, 'get', params);
};
